import { ENTITY_DETAIL_NAME } from '@/model/form-builder';
import { DEFAULT_MEMBER_DETAIL } from '@/studbook/store/useMemberFilterStore';

// Default visible fields for enterprise member list (admin view)
export const defaultEnterpriseVisibleFields = [
  ENTITY_DETAIL_NAME.ENTERPRISE_IDENT,
  ENTITY_DETAIL_NAME.NAME,
  ENTITY_DETAIL_NAME.FIRST_NAME,
  ENTITY_DETAIL_NAME.LAST_NAME,
  ENTITY_DETAIL_NAME.EMAIL,
  ENTITY_DETAIL_NAME.PHONE,
];

// Default visible fields for public search member filter
export const defaultPublicSearchVisibleFields = [
  DEFAULT_MEMBER_DETAIL.NAME,
  DEFAULT_MEMBER_DETAIL.MEMBER_IDENT,
  DEFAULT_MEMBER_DETAIL.STUD_NAME,
  DEFAULT_MEMBER_DETAIL.HERD_IDENT,
  DEFAULT_MEMBER_DETAIL.HERD_PREFIX,
];

// Fields that should have links in enterprise context
export const enterpriseEntityDetailWithLink = [
  ENTITY_DETAIL_NAME.ENTERPRISE_IDENT,
  ENTITY_DETAIL_NAME.NAME,
] as string[];

// Fields that should have links in public search context
export const publicSearchEntityDetailWithLink = [
  DEFAULT_MEMBER_DETAIL.NAME,
] as string[];

// Column width mapping for member columns
export const memberColumnWidthMap: Record<string, number> = {
  [DEFAULT_MEMBER_DETAIL.NAME]: 200,
  [DEFAULT_MEMBER_DETAIL.MEMBER_IDENT]: 150,
  [DEFAULT_MEMBER_DETAIL.STUD_NAME]: 150,
  [DEFAULT_MEMBER_DETAIL.HERD_IDENT]: 150,
  [DEFAULT_MEMBER_DETAIL.HERD_PREFIX]: 150,
  [ENTITY_DETAIL_NAME.MEMBERSHIP]: 250,
};
